import React from "react";
import {Select, Tabs} from "antd";
import {ListSymbolItem} from '../../Components/ListSymbols/ListSymbols'
import styles from './SymbolsSelector.module.css'
import listSymbolStyles from '../../Components/ListSymbols/ListSymbols.module.css';

const {TabPane} = Tabs;
const {Option} = Select;

export default class SymbolsSelector extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            removeBackground: {
                id: -1,
                name: 'None',
                desc: 'None'
            },
            activeType: null,
        };
    }

    componentDidMount() {
        const {symbolsTypes} = this.props;
        this.setState({activeType: symbolsTypes[0]});
        this.undoRedoListener();
    };

    undoRedoListener = () => {
        const {graph} = this.props;
        graph.manager.addListener(window.mxEvent.UNDO, this.listener);
        graph.manager.addListener(window.mxEvent.REDO, this.listener);
    };

    componentWillUnmount() {
        const {graph} = this.props;
        graph.manager.removeListener(this.listener);
    }

    listener = () => {
        const {graph, recreateSchematicsTabs} = this.props;
        recreateSchematicsTabs(graph.getModel().getRoot().exportJson().elements);
    };

    componentDidUpdate(prevProps) {
        const {symbolsTypes, graph} = this.props;
        if (prevProps.symbolsTypes !== symbolsTypes) {
            this.setState({activeType: symbolsTypes[0]});
        }
        if (graph && prevProps.graph !== graph) {
            this.undoRedoListener();
        }
    }

    onTypeChange = (id) => {
        const {symbolsTypes} = this.props;
        const activeType = symbolsTypes.find(t => t.id === id);
        this.setState({activeType})

    };

    clearBackground = () => {
        const {graph} = this.props;
        graph.clearBackgroundShape();
        this.forceUpdate();
    };
    setBackground = (background) => {
        const {graph, activeSchematicType} = this.props;
        let tempData = background.data;
        try {
            background.data = JSON.parse(tempData);
        } catch (e) {
            background.data = tempData;
        }
        graph.setBackgroundShape(background, activeSchematicType);
        this.forceUpdate();

    };

    get isBackgroundSelect() {
        const {graph} = this.props;
        return graph && graph.getActivePage().getBackground();
    }


    render() {
        const {previewSymbol, backgrounds, symbolsTypes, setActiveSymbol, schematicList, graph, sidebarVisible, setSchematicElement} = this.props;
        const {activeType, removeBackground} = this.state;
        return (
            <>
                <div className={styles.symbols_container}>
                    {activeType ? <div>
                        <span className={styles.symbols_title}>Type:</span>
                        <div className={styles.graph_settings}>
                            <Select value={activeType.id} style={{width: 150}}
                                    onChange={this.onTypeChange}>
                                {symbolsTypes.map((typeFigure) => {
                                    return (
                                        <Option key={typeFigure.id}
                                                value={typeFigure.id}>{typeFigure.name}</Option>
                                    )
                                })}
                            </Select>
                        </div>
                    </div> : null}
                </div>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Symbols" key="1">
                        <div className={styles.library_container}>
                            {activeType ? activeType.symbols.map((figure) => {
                                const active = previewSymbol && figure.id === previewSymbol.id ? true : false;
                                return <ListSymbolItem active={active}
                                                       key={figure.id}
                                                       schematicList={schematicList}
                                                       sidebarVisible={sidebarVisible}
                                                       graph={graph}
                                                       setSchematicElement={setSchematicElement}
                                                       handleClick={setActiveSymbol}
                                                       symbol={figure}/>
                            }) : null}
                        </div>
                    </TabPane>
                    <TabPane tab="Schematic" key="2">
                        <div className={styles.library_container}>
                            {schematicList.length ? schematicList.map(symbol => {
                                const active = previewSymbol && symbol.id === previewSymbol.id ? true : false;
                                return <ListSymbolItem active={active}
                                                       key={symbol.id}
                                                       graph={graph}
                                                       setSchematicElement={setSchematicElement}
                                                       sidebarVisible={sidebarVisible}
                                                       schematicList={schematicList}
                                                       handleClick={setActiveSymbol}
                                                       symbol={symbol}/>
                            }) : null}
                        </div>
                    </TabPane>
                    <TabPane tab="Background" key="3">
                        <div
                            className={!this.isBackgroundSelect ? `${listSymbolStyles.symbol_row} ${listSymbolStyles.active}` : `${listSymbolStyles.symbol_row}`}
                            onClick={this.clearBackground}>
                            <span className={listSymbolStyles.symbol_row_name}>{removeBackground.name}</span>
                            <span className={listSymbolStyles.symbol_row_name}>{removeBackground.desc}</span>
                        </div>
                        {backgrounds.map((background) => {
                            const active = this.isBackgroundSelect && background.id === this.isBackgroundSelect.backgroundId ? true : false;
                            return (
                                <ListSymbolItem symbol={background}
                                                key={background.id}
                                                sidebarVisible={sidebarVisible}
                                                handleClick={this.setBackground}
                                                active={active}/>
                            )
                        })}
                    </TabPane>
                </Tabs>
            </>
        )
    }
}
